"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountDetectionApi = accountDetectionApi;
exports.copyrightInfoApi = copyrightInfoApi;
exports.frontDomainApi = frontDomainApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取版权信息
 */
function copyrightInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/copyright/get/company/info',
    method: 'get'
  });
}

/**
 * @description 账号登录检测
 */
function accountDetectionApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/login/account/detection',
    method: 'post',
    data: data
  });
}

/**
 * 获取移动端域名
 */
function frontDomainApi() {
  return (0, _request.default)({
    url: '/publicly/config/get/front/domain',
    method: 'get'
  });
}